
window.addEventListener( 'alpine:init', () => bootstrap() );

export default() => ({
	$header: null,
	header_visible: true,
	expanded: false,
	last_viewport_width: null,
	boundary_width: 768,
	$admin_bar: null,
	init() {
		this.$header = document.getElementById('site-header');
		this.$admin_bar = document.getElementById('wpadminbar');
		this.last_viewport_width = this.viewport_width;
		this.checkWidth();
		this.setHeight();
		this.setOffset();
		this.setupMutationObserver();
	},
	onScroll() {
		this.setHeight();
	},
	clearFilters() {
		this.$dispatch('clear-filters');
	},
	apply() {
		this.expanded = false;
	},
	get viewport_width() {
		return parseInt(document.body.clientWidth, 10);
	},
	checkWidth() {
		const width = this.viewport_width;
		if (
			this.last_viewport_width < this.boundary_width
			&& width >= this.boundary_width
		) {
			// Crossed from mobile to desktop
			this.expanded = true;
		} else if (
			this.last_viewport_width >= this.boundary_width
			&& width < this.boundary_width
		) {
			// Crossed from desktop to mobile
			this.expanded = false;
		} else if (
			this.last_viewport_width >= this.boundary_width
			&& width > this.boundary_width
		) {
			this.expanded = true;
		}

		this.last_viewport_width = width;
	},
	setHeight() {
		let height = 0;
		if ( this.viewport_width >= this.boundary_width || this.header_visible ) {
			height = this.$header.clientHeight;
		}
		this.$root.style.setProperty('--header-height', height + 'px');
	},
	onResize() {
		this.setOffset();
		this.checkWidth();
	},
	setOffset() {
		let offset = 14;
		if ( this.viewport_width < this.boundary_width || !this.header_visible ) {
			offset = 0;
		}
		if ( this.$admin_bar ) {
			offset += this.$admin_bar.clientHeight;
		}
		this.$root.style.setProperty('--stick-offset', offset + 'px');
	},
	setupMutationObserver() {
		const config = { attributes: true };
		const observer = new MutationObserver(
			(mutation_list) => this.mutationCallback(mutation_list)
		);
		observer.observe(this.$header, config);
	},
	mutationCallback(mutation_list) {
		for ( const mutation of mutation_list ) {
			if ( mutation.attributeName === 'class' ) {
				if ( mutation.target.classList.contains('js-hide') ) {
					this.header_visible = false;
				} else {
					this.header_visible = true;
				}
				this.setOffset();
				this.setHeight();
			}
		}
	},
});

function bootstrap() {
	document.querySelectorAll('.js-filter-group')
		.forEach( $el => bootstrapControl($el) )
	;
}

function bootstrapControl($root) {
	$root.setAttribute('x-data', 'filterGroup');
	$root.setAttribute(':class', '{ "is-expanded": expanded }');
	$root.setAttribute('x-on:scroll.window.throttle.200ms', 'onScroll');
	$root.setAttribute('x-on:resize.window.throttle.200ms', 'onResize');

	// Group filter controls for hide/show
	const $group = document.createElement('div');
	$group.setAttribute('x-show', 'expanded');
	$group.setAttribute('x-cloak', '');
	$group.setAttribute('class', 'c-filter-group__body');

	// Shortcodes _after_ the heading
	const $filter_controls = $root.querySelectorAll('.c-filter-group__heading ~ .vcex-shortcode');
	$filter_controls.forEach( _ => $group.append(_) );

	const $heading = $root.querySelector('.c-filter-group__heading');
	$heading.setAttribute('x-on:click', 'expanded=!expanded');
	$heading.parentNode.append($group);
	$heading.parentNode.classList.add('c-filter-group__container');

	const $footer = document.createElement('footer');
	$footer.setAttribute('x-show', 'expanded');
	$footer.setAttribute('class', 'c-filter-group__footer');
	$footer.insertAdjacentHTML(
		'afterbegin',
		'<button class="is-clear" x-on:click="clearFilters">x Clear Filters</button><button class="is-apply" x-on:click="apply">Apply</button>'
	);
	$heading.parentNode.append($footer);
}
